import React from 'react';

const ServiceCard = ({ service, onClick }) => {
  const nameDisplay = service.is_individual
    ? (
        <>
          <h3>{service.individual_name}</h3>
          <p style={{ fontSize: "90%", opacity: 0.7 }}>{service.business_name}</p>
        </>
      )
    : <h3>{service.business_name}</h3>;

  return (
    <div className="service-card" onClick={() => onClick(service)}>
      <img src={service.image_url || "https://firebasestorage.googleapis.com/v0/b/fireup-da7fe.appspot.com/o/services.png?alt=media&token=070a7af9-adae-4020-a8c5-849dc975b7ee"} alt={nameDisplay} className="service-icon" />
        <div className="service-info">
            {nameDisplay}
            <p>{service.description}</p>
            <div className="location-info" style={{ fontWeight: 'bold' }}>{service.location}</div>
            <div className="tags-container">
                {service.types && service.types.map((type, index) => <span key={index} className="resource-tag" style={{}}>{type}</span>)}
            </div>
            <div className="contact-info">
                <p><i className="fa-solid fa-globe"></i> <a href={service.url} target="_blank" rel="noopener noreferrer">{new URL(service.url).hostname}</a>
                </p>
            </div>
            {service.contact.email && (
                <div className="contact-info">
                    <p><i className="fa-solid fa-envelope"></i> <a
                        href={`mailto:${service.contact.email}`}>{service.contact.email}</a></p>
                </div>
            )}
            {service.contact.phone && (
                <div className="contact-info">
                    <p><i className="fa-solid fa-phone"></i> <a
                        href={`tel:+1${service.contact.phone.replace(/\D/g, '')}`}>{service.contact.phone}</a></p>
                </div>
            )}
        </div>
    </div>
  );
};

export default ServiceCard;
